export const gloriafood = {
  seo: {
    title: 'Gloriafood schließt? Wechsle kostenlos zu Bistroo',
    description:
      'Gloriafood stellt den Betrieb am 30. April 2027 ein. Wechsle jetzt zu Bistroo: kostenlos bis zum 1. Mai 2027 und dein eigener Webshop in unter 30 Minuten live.',
  },
  hero: {
    badge: 'Wichtig für Gloriafood-Restaurants',
    title_1: 'Gloriafood schließt.',
    title_em: 'Dein neues Zuhause ist bereit.',
    subtitle:
      'Gloriafood stellt am 30. April 2027 alle Dienste ein. Tausende Restaurants brauchen dann eine neue Bestelllösung. Bistroo ist für dich bereit, und bis dahin zahlst du nichts.',
    offer_pt1: 'Kostenloses Abo bis einschließlich',
    offer_date: '30. April 2027',
    offer_pt2: ', dem Tag, an dem Gloriafood abschaltet.',
    cta_primary: 'Webshop erstellen, kostenlos',
    cta_secondary: 'Mit unserem Team sprechen',
    reassurance: 'Keine Kreditkarte nötig. In unter 30 Minuten live. Monatlich kündbar.',
  },
  countdown: {
    label: 'Verbleibende Zeit bis Gloriafood schließt',
    units: {
      months: 'Monate',
      days: 'Tage',
      hours: 'Stunden',
      minutes: 'Minuten',
    },
    cta_text: 'Jeder Tag Warten ist ein Tag näher an einem Webshop, der offline geht.',
    cta_link: 'Heute wechseln',
  },
  trust: {
    items: [
      { icon: 'bi-lightning-charge-fill', text: 'In unter 30 Minuten live' },
      { icon: 'bi-credit-card-2-front-fill', text: 'Keine Einrichtungskosten' },
      { icon: 'bi-unlock-fill', text: 'Kein Langzeitvertrag' },
      { icon: 'bi-headset', text: 'Persönliche Hilfe beim Wechsel' },
    ],
  },
  timeline: {
    kicker: 'Was passiert',
    heading: 'Die Uhr tickt für Gloriafood-Restaurants',
    lead: 'Das solltest du wissen, und das ist jetzt zu tun.',
    items: [
      {
        icon: 'bi-megaphone-fill',
        date: 'Jetzt',
        title: 'Gloriafood kündigt das Ende an',
        text: 'Gloriafood hat angekündigt, alle Dienste einzustellen. Tausende Restaurants müssen sich deshalb nach einer neuen Lösung für Online-Bestellungen umsehen.',
      },
      {
        icon: 'bi-exclamation-triangle-fill',
        date: '30. April 2027',
        title: 'Die Gloriafood-Server gehen aus',
        text: 'Alle Webshops, Websites und Bestellseiten, die auf Gloriafood laufen, funktionieren nicht mehr. Keine Bestellungen mehr, kein Umsatz mehr.',
      },
      {
        icon: 'bi-check-circle-fill',
        date: 'Heute',
        title: 'Kostenlos zu Bistroo wechseln',
        text: 'Melde dich jetzt an und nutze deinen vollständigen Bistroo-Webshop kostenlos bis zum 30. April 2027. So wechselst du in deinem eigenen Tempo, ohne Hektik und ohne doppelte Kosten.',
      },
    ],
  },
  why: {
    kicker: 'Die richtige Wahl',
    heading: 'Warum Bistroo die logische Alternative ist',
    lead: 'Nicht einfach ein weiteres Webshop-Tool. Bistroo ist von Grund auf für Restaurants wie deins gebaut.',
    items: [
      {
        title: 'Dein Webshop gehört vollständig dir',
        text: 'Deine Marke, deine Domain, deine Gästedaten. Zwischen dir und deinen Gästen steht kein Marktplatz: Bestellungen, Umsatz und Beziehungen bleiben bei dir.',
      },
      {
        title: 'Next-Gen-Design, sofort einsatzbereit',
        text: 'Bistroo-Webshops sehen wirklich modern aus. Mit anpassbaren Vorlagen zeigt dein Webshop die Qualität deines Essens, statt einer generischen Bestellseite von 2015.',
      },
      {
        title: 'Eine komplette Suite zu einem zugänglichen Preis',
        text: 'Webshop, Website, QR-Bestellung, Kiosk und Kasse gehören zum selben Ökosystem. Ein Monatsabo, transparente Tarife, alles im Bistroo Manager verwaltet.',
      },
      {
        title: 'Ein Partner, kein Lieferant',
        text: 'Bistroo ist monatlich kündbar, weil wir dein Vertrauen jeden Monat neu verdienen wollen. Kein Lock-in und keine Überraschungen im Nachhinein.',
      },
    ],
  },
  features: {
    kicker: 'Warum Bistroo',
    heading: 'Alles, was du bei Gloriafood hattest, und mehr',
    lead: 'Speziell gebaut für Quick-Service, Abholung und Lieferung. Kein Nebenschauplatz, sondern genau das, wofür unsere Software gemacht ist.',
    items: [
      {
        icon: 'bi-shop',
        title: 'Ein Webshop in deinem eigenen Look',
        text: 'Eigene Domain, eigene Farben und anpassbare Vorlagen. Gäste bestellen direkt bei dir, nicht über einen Marktplatz.',
      },
      {
        icon: 'bi-phone',
        title: 'Vollständige Auftragsverwaltung',
        text: 'Nimm jede Bestellung im Bistroo Manager in Echtzeit an, verwalte und verfolge sie. Menüs, Öffnungszeiten und Preise passt du selbst direkt an.',
      },
      {
        icon: 'bi-cash-coin',
        title: 'Transparente, faire Tarife',
        text: 'Ein Monatsabo ohne Überraschungen. Du weißt immer, woran du bist, und deine Gästedaten bleiben deine.',
      },
      {
        icon: 'bi-lightning-charge',
        title: 'Self-Service, Plug & Play',
        text: 'Kein Entwickler nötig. Menü aufsetzen, Auszahlungen über Stripe verbinden und live gehen, alles innerhalb von 30 Minuten.',
      },
      {
        icon: 'bi-globe-europe-africa',
        title: 'Wächst mit dir durch Europa',
        text: 'Aktiv in den Niederlanden und Belgien, später in 2026 auch in Deutschland. Gebaut, um mit deinen Ambitionen mitzuwachsen.',
      },
      {
        icon: 'bi-headset',
        title: 'Persönlicher Kundenservice',
        text: 'Ein echtes Team, das abnimmt. Wir sind da, wenn es am hektischsten ist und am meisten zählt.',
      },
    ],
  },
  offer: {
    heading: 'Kostenlos bis zum letzten Tag von Gloriafood.',
    text: 'Wechsle jetzt und zahle nichts bis zum 1. Mai 2027. Dein Abo startet erst in dem Moment, in dem Gloriafood aufhört, nicht früher.',
    button: 'Kostenlosen Zeitraum sichern',
    note: '* Das Angebot gilt für das Standard-Abo von Bistroo Webshop, für Restaurants, die vor dem 30. April 2027 von Gloriafood wechseln.',
  },
  steps: {
    kicker: 'In 3 Schritten',
    heading: 'In unter 30 Minuten online',
    items: [
      {
        title: 'Erstelle dein kostenloses Konto',
        text: 'Registriere dich auf merchant.bistroo.nl. Keine Kreditkarte, keine Verpflichtungen. In 2 Minuten erledigt.',
      },
      {
        title: 'Richte Menü und Webshop ein',
        text: 'Gib dein Menü ein, wähle eine Vorlage und stelle Domain und Öffnungszeiten ein. Alles selbst, im Bistroo Manager.',
      },
      {
        title: 'Geh live und nimm Bestellungen an',
        text: 'Verbinde Stripe für deine Auszahlungen, veröffentliche deinen Webshop und teile deinen Link oder QR-Code mit deinen Gästen.',
      },
    ],
    button: 'Meinen kostenlosen Webshop starten',
  },
  contact: {
    kicker: 'Mit unserem Team sprechen',
    heading: 'Lieber eine persönliche Einführung?',
    lead: 'Hinterlasse deine Daten und einer unserer Restaurant-Spezialisten meldet sich innerhalb eines Werktages, um dich durch den Wechsel zu begleiten. Kostenlos.',
    perks: [
      'Wir helfen dir, dein Menü von Gloriafood zu übernehmen',
      'Kostenlose Hilfe beim Einrichten deines Webshop-Designs',
      'Keine Abokosten bis zum 1. Mai 2027',
      'Monatlich kündbar, ohne Langzeitvertrag',
    ],
    card: {
      title: 'Wechsel anfragen',
      text: 'Füll das Kontaktformular aus, wir melden uns innerhalb eines Werktages. Willst du dich lieber erst selbst umsehen? Dann erstelle direkt dein kostenloses Konto.',
      button: 'Zum Kontaktformular',
      secondary: 'Direkt kostenloses Konto erstellen',
      disclaimer: 'Wir antworten innerhalb eines Werktages. Niemals Spam.',
    },
  },
  faq: {
    title_pt1: 'Häufige Fragen zum',
    title_pt2: 'Wechsel',
    items: [
      {
        q: 'Wie funktioniert der kostenlose Zeitraum genau?',
        a: 'Melde dich vor dem 30. April 2027 an und gib an, dass du von Gloriafood wechselst. Wir aktivieren dein Konto ohne Abokosten bis zum 1. Mai 2027. Danach gilt das Standard-Monatsabo, das du jeden Monat kündigen kannst.',
      },
      {
        q: 'Kann ich mein Menü von Gloriafood mitnehmen?',
        a: 'Ja. Melde dich bei unserem Team, dann helfen wir dir beim Übertragen. Lieber selbst machen? Mit dem Menü-Builder im Bistroo Manager legst du Kategorien, Optionen, Fotos und Preise schnell an.',
      },
      {
        q: 'Brauche ich technische Kenntnisse für den Wechsel?',
        a: 'Nein. Bistroo ist vollständig Self-Service: Der Bistroo Manager ist so gebaut, dass du als Restaurantbesitzer alles selbst einrichtest und verwaltest, ohne Entwickler. Wenn du doch feststeckst, hilft dir unser Support-Team persönlich weiter.',
      },
      {
        q: 'Was passiert nach dem kostenlosen Zeitraum?',
        a: 'Ab dem 1. Mai 2027 wechselst du in das Standard-Monatsabo von Bistroo. Du kannst jederzeit ändern oder kündigen; wir arbeiten nicht mit Langzeitverträgen.',
      },
      {
        q: 'Ist Bistroo in meinem Land verfügbar?',
        a: 'Bistroo ist in den Niederlanden und Belgien live, und später in 2026 starten wir in Deutschland. Bist du woanders? Melde dich, dann halten wir dich über unsere Expansion auf dem Laufenden.',
      },
    ],
  },
  cta: {
    heading_1: 'Warte nicht, bis das Licht ausgeht.',
    heading_em: 'Wechsle heute.',
    text: '30 Minuten Einrichtung. Kostenlos, bis Gloriafood aufhört. Kein Risiko.',
    button_primary: 'Meinen kostenlosen Webshop starten',
    button_secondary: 'Kontakt aufnehmen',
  },
}
